<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4PMrjC/tc-custom/9780765397379.jpg?1737775934151" alt="This image is the cover for the book The Barrow Will Send What It May, Danielle Cain"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Barrow Will Send What It May, Danielle Cain
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Margaret Killjoy’s Danielle Cain series is a dropkick-in-the-mouth anarcho-punk fantasy that pits traveling anarchist Danielle Cain against eternal spirits, hypocritical ideologues, and brutal, unfeeling officers of the law. The story continues with <i>The Barrow Will Send What it May</i>.</b><br/><br/>Now a nascent demon-hunting crew on the lam, Danielle and her friends arrive in a small town that contains a secret occult library run by anarchists and residents who claim to have come back from the dead. When Danielle and her crew investigate, they are put directly in the crosshairs of a necromancer’s wrath — whose actions threaten to trigger the apocalypse itself.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Killjoy
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tor.com
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b22f408